// import { ability, updateAbility } from 'utils/permissions';
import {
  GET_MENTIONS,
  CREATE_MENTION,
  EDIT_MENTION,
} from '../actions/coverageActions';

const initialState = {
  mentions: {
    loading: true,
    loaded: false,
    results: [],
  },
};


// eslint-disable-next-line import/prefer-default-export
export const mentionReducer = (state = initialState.mentions, action) => {
  switch (action.type) {
    case GET_MENTIONS.pending:
      return {
        loading: true,
        loaded: false,
        results: [],
      };
    case GET_MENTIONS.success:
      return {
        loading: false,
        loaded: true,
        ...action.payload.data,
      };
    case GET_MENTIONS.error:
      return {
        ...state,
        loading: false,
        loaded: true,
      };
    case CREATE_MENTION.pending:
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    case CREATE_MENTION.success:
      return {
        ...state,
        loading: false,
        loaded: true,
        results: [
          action.payload.data,
          ...state.results,
        ],
      };
    case CREATE_MENTION.error:
      return {
        ...state,
        loading: false,
        loaded: true,
      };
    case EDIT_MENTION.pending:
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    case EDIT_MENTION.success:
      return {
        ...state,
        loading: false,
        loaded: true,
        results: state.results.map((mention) => {
          if (mention.id === action.payload.data.id) {
            return action.payload.data;
          }
          return mention;
        }),
      };
    case EDIT_MENTION.error:
      return {
        ...state,
        loading: false,
        loaded: true,
      };
    default:
      return state;
  }
};
